import { lazyWeixinJsSdk } from '@utils/lazylib';
import { login } from '@bbtfe/webview-bridge';
import { isInMiniProgram } from './development';
import { NEXT_SHOP_HOST } from '@utils/constant/domain';

/**
 * 去登录
 * @param {*} successCallback //登录成功回调
 * @param {*} miniLoginUrl
 */
export const gotoLogin = (
  miniLoginUrl = '/pages/auth/index' // 默认美囤小程序登录链接
) => {
  if (bbtNative.isApp()) {
    // 跳转到app登录.
    login();
  } else if (isInMiniProgram()) {
    lazyWeixinJsSdk().then(wx => {
      wx.miniProgram.navigateTo({ url: miniLoginUrl });
    });
  } else {
    window.location.href = `${NEXT_SHOP_HOST()}/login?url=${encodeURIComponent(
      location.href
    )}`;
  }
};
